// Enable to use all possible polyfills (huge)
/*
import 'core-js/stable'
import 'regenerator-runtime/runtime'
*/

import './scss/global.scss'

import './helpers/feature-detections'
import './helpers/polyfills'
import './helpers/global-events'

import Vue from 'vue'

import Grub from './grub-loader'
import Logger from './logger'
import Router from './router'
import AnalyticsLoader from './analytics-loader'
import StateLoader from './storage/state-loader'
import Store from './store'

import { ACTIONS } from './store/actions'
import { MUTATIONS } from './store/mutations'

// Global Components
import App from './App.vue'
import './components/global'

// Plugins
import loadScheme from './plugins/Scheme'
import loadConfig from './plugins/Config'
import loadEventBus from './plugins/EventBus'
import loadLogger from './plugins/Logger'
import loadServerValidator from './plugins/ServerValidator'

/**
 * Enable access to a global reference.
 * @type {Window}
 */
Vue.prototype.Externals = window

async function init() {
    await Grub.load()

    const Scheme = await loadScheme()

    Vue.use(Scheme)
    Vue.use(loadConfig())
    Vue.use(loadEventBus())
    Vue.use(loadLogger())
    Vue.use(loadServerValidator())

    Vue.config.productionTip = false

    const analyticsLoader = new AnalyticsLoader()

    await analyticsLoader.loadAsync()

    const loggingCategory = 'Initialisation'

    try {
        await new StateLoader(Store).loadAsync()
        Logger.log('Household State Initialised', loggingCategory)

        new Vue({
            router: Router,
            store: Store,
            render: h => h(App),
        }).$mount('#app')
    } catch (err) {
        if (err && String(err).includes('Expects string as the type, but found undefined.')) {
            Logger.error('Unable to start application due to an error with Vuex ACTION or MUTATION name definitions', loggingCategory)
            Logger.logObject({
                error: err,
                ACTIONS,
                MUTATIONS,
            }, 'Vuex definitions', loggingCategory)
        } else {
            Logger.error(`Unable to start application due to an error loading state (${ err })`, loggingCategory)
        }
    }
}

// noinspection JSIgnoredPromiseFromCall
init()

// We need to create a temporary function here that will be replaced later.
// eslint-disable-next-line require-await
window.recaptchaVerify = async function() {
    // eslint-disable-next-line no-console
    console.warn('RECAPTCHA Verification unbound')
    return false
}
